import Container from './styled/Container'

const SelectListMeta = Container

export default /** @type any */(SelectListMeta)
